import { RouterView, type RouteRecordRaw } from 'vue-router';

// Note for maintainers:
// This file contains the real design guide routes for non-production builds.
// In production, the import path `@/router/designGuideRoutes` is aliased in
// `vite.config.js` to `designGuideRoutes.prod.ts`, which exports an empty array.
// This keeps docs routes out of prod routing and out of the prod bundle.

// Design Library
const BorderOverview = () => import('@/views/design/BorderOverview.vue');
const TypographyOverview = () =>
  import('@/views/design/TypographyOverview.vue');
const IconSizesOverview = () => import('@/views/design/IconSizesOverview.vue');
const IconOverview = () => import('@/views/design/IconOverview.vue');
const ColorPalette = () => import('@/views/design/ColorPaletteOverview.vue');
const SpacingOverview = () => import('@/views/design/SpacingOverview.vue');
const FormOverview = () => import('@/views/design/FormOverview.vue');
const AlertOverview = () => import('@/views/design/AlertOverview.vue');
const TooltipSnackbarOverview = () =>
  import('@/views/design/TooltipSnackbarOverview.vue');
const ButtonOverview = () => import('@/views/design/ButtonOverview.vue');
const ChipsOverview = () => import('@/views/design/ChipsOverview.vue');
const CardsOverview = () => import('@/views/design/CardOverview.vue');
const ExpansionPanelsOverview = () =>
  import('@/views/design/ExpansionPanelsOverview.vue');
const OtherComponentsOverview = () =>
  import('@/views/design/OtherComponentsOverview.vue');
const SkeletonLoaderOverview = () =>
  import('@/views/design/SkeletonLoaderOverview.vue');
const IconExport = () => import('@/views/design/IconExport.vue');

// Prototypes
// ⚠️  MAINTENANCE NOTE: If removing designGuidePrototypeRoutes, update
//    scripts/screenshot-prototypes.ts to manually maintain prototype discovery.
const HelloWorld = () => import('@/views/prototypes/HelloWorld.vue');

export const designGuidePrototypeRoutes: RouteRecordRaw[] = [
  {
    component: HelloWorld,
    meta: { unguarded: true },
    name: 'design.prototype.hello-world',
    path: 'hello-world'
  }
];

const DesignOverview = () => import('@/views/design/DesignOverview.vue');
const DesignGuideNavigation = () =>
  import('@/contexts/designGuide/DesignGuideNavigation.vue');

const designGuideChildRoutes: RouteRecordRaw[] = [
  {
    component: BorderOverview,
    name: 'design.border',
    path: 'border'
  },
  {
    component: TypographyOverview,
    name: 'design.typography',
    path: 'typography'
  },
  {
    component: IconOverview,
    name: 'design.icons',
    path: 'icons'
  },
  {
    component: IconSizesOverview,
    name: 'design.icon-sizes',
    path: 'icon-sizes'
  },
  {
    component: ColorPalette,
    name: 'design.color-palette',
    path: 'color-palette'
  },
  {
    component: SpacingOverview,
    name: 'design.spacing',
    path: 'spacing'
  },
  {
    component: FormOverview,
    name: 'design.form',
    path: 'form'
  },
  {
    component: AlertOverview,
    name: 'design.alert',
    path: 'alert'
  },
  {
    component: TooltipSnackbarOverview,
    name: 'design.tooltip-snackbar',
    path: 'tooltip-and-snackbar'
  },
  {
    component: ButtonOverview,
    name: 'design.buttons',
    path: 'buttons'
  },
  {
    component: ChipsOverview,
    name: 'design.chips',
    path: 'chips'
  },
  {
    component: CardsOverview,
    name: 'design.cards',
    path: 'cards'
  },
  {
    component: ExpansionPanelsOverview,
    name: 'design.expansion-panels',
    path: 'expansion-panels'
  },
  {
    component: OtherComponentsOverview,
    name: 'design.other-components',
    path: 'other-components'
  },
  {
    component: SkeletonLoaderOverview,
    name: 'design.skeleton-loaders',
    path: 'skeleton-loaders'
  },
  {
    component: IconExport,
    name: 'design.icon-export',
    path: 'icon-export'
  },
  // Prototypes automatically added below
  {
    component: RouterView,
    meta: { unguarded: true },
    name: 'design.prototypes',
    path: 'prototypes',
    children: designGuidePrototypeRoutes
  }
];

export const designGuideRoutes: RouteRecordRaw[] = [
  {
    components: {
      default: RouterView,
      LeftSidebar: DesignGuideNavigation
    },
    meta: { unguarded: true },
    name: 'design',
    path: '/design',
    redirect: { name: 'design.overview' },
    children: [
      {
        component: DesignOverview,
        name: 'design.overview',
        path: ''
      },
      ...designGuideChildRoutes
    ]
  }
];
